export const AddressZero = "0x0000000000000000000000000000000000000000";

export const THE_GRAPH_ENDPOINT =
  "https://api.thegraph.com/subgraphs/name/0xr3c0nf1gur3d/spex-universe";
